<template>

    <div class="header">

        <div class="d-flex align-items-center">
            <a class="logo" href="#" @click.prevent="push('home')">
                <img src="/img/crowdpower-logo.svg" height="26" width="auto" title="CrowdPower" />
            </a>
        </div>

        <div class="nav d-none d-md-block">
            <div class="nav-item position-relative" v-click-outside="hideMenu">
                <a class="nav-link" :class="{ 'active' : showFeaturesMenu }" href="#" @click.prevent="showFeaturesMenu = !showFeaturesMenu">
                    <span>Features<i class="fa-solid fa-caret-down ml-5"></i></span>
                </a>
                <transition name="dropdown">
                    <v-features v-show="showFeaturesMenu" @close="showFeaturesMenu = false" />
                </transition>
            </div>
            <div class="nav-item">
                <router-link class="nav-link" :to="{ name: 'pricing' }">Pricing</router-link>
            </div>
            <div class="nav-item">
                <a class="nav-link" href="https://docs.crowdpower.io" target="_blank">Docs</a>
            </div>
            <div class="nav-item">
                <a class="nav-link" :href="appUrl + '/login'">Log In</a>
            </div>
            <div class="nav-item">
                <a class="nav-link accent" :href="appUrl + '/signup'">Start Free Trial</a>
            </div>
        </div>

        <div class="hamburger d-md-none">
            <a class="hamburger-toggle" href="#" @click.prevent="showMobileMenu = !showMobileMenu">
                <i class="fas fa-bars"></i>
            </a>
            <transition name="dropdown">
                <div v-show="showMobileMenu" class="hamburger-menu">
                    <div class="dropdown-menu dropdown-menu-lg">
                        <v-close @click.native="showMobileMenu = false" />
                        <a :href="appUrl+'/signup'" class="dropdown-item">Start Free Trial</a>
                        <a :href="appUrl+'/login'" class="dropdown-item">Log In</a>
                        <a class="dropdown-item" href="#" @click.prevent="push('pricing')">Pricing</a>
                        <a class="dropdown-item" href="https://docs.crowdpower.io" target="_blank">Docs</a>
                        <a class="dropdown-item" href="#" @click.prevent="push('contact')">Contact Us</a>
                    </div>
                </div>
            </transition>
        </div>

    </div>

</template>

<style scoped lang="scss">

    .header {

        align-items: center;
        background: $color-bg;
        display: flex;
        flex-shrink: 0;
        justify-content: space-between;
        min-height: 60px;
        padding: 10px 15px;
        position: fixed;
        width: 100%;
        z-index: 1000;

        .logo {
            align-items: center;
            display: flex;
            text-decoration: none;
            transition: opacity .3s;
            @media (hover: hover) {
                &:hover {
                    opacity: 0.7;
                }
            }
        }

        .nav {
            .nav-item {
                float: left;
            }
            .nav-link {
                @include font-semibold(12px);
                border-radius: 5px;
                color: $color-text;
                display: block;
                line-height: 40px;
                opacity: 1;
                padding: 0 10px;
                text-decoration: none;
                transition: all .3s;
                &:hover, &:hover.active {
                    color: $color-link-hover;
                }
                &.active, &.router-link-active {
                    color: $color-link;
                }
                &.accent {
                    background: $color-primary;
                    color: #fff;
                    margin-left: 10px;
                    padding: 0 15px;
                    &:hover, &:hover.active {
                        background: $color-link-hover;
                        color: #fff;
                    }
                }
            }
        }
    }

</style>

<script>

import ClickOutside from 'vue-click-outside';
import TheHeaderFeatures from '@cmp/TheHeaderFeatures';

export default {

    directives: {
        ClickOutside,
    },

    components: {
        'v-features': TheHeaderFeatures,
    },

    data() {
        return {
            appUrl: process.env.VUE_APP_APP_URL,
            showMobileMenu: false,
            showFeaturesMenu: false,
        }
    },

    methods: {

        hideMenu() {
            this.showFeaturesMenu = false;
        },

        push(name) {
            this.showMobileMenu = false;
            if (this.$route.name !== name) {
                this.$router.push({ name: name });
            }
        },

    },

}

</script>
